<template>
  <b-row>
    <b-col>
      <div v-if="!isLoading">
        <b-alert
          :show="dismissCountDownSuccess"
          dismissible
          variant="success"
          @dismissed="dismissCountDownSuccess = 0"
          @dismiss-count-down="countDownSuccessChanged"
          >{{ "Les mentions légales ont été mises à jour !" }}</b-alert
        >
        <b-alert
          :show="dismissCountDownError"
          dismissible
          variant="danger"
          @dismissed="dismissCountDownError = 0"
          @dismiss-count-down="countDownErrorChanged"
          >{{ "Il y a un problème lors de la mise à jour des mentions légales!" }}</b-alert
        >
        <tiptap
          v-model="legalMentions"
          :placeholder="'Entrez les mentions légales'"
          @updateOnFocusOut="updateText"
        />
        <b-button
          v-if="!isNew"
          :disabled="isDisabled"
          class="button btn-blue my-4 fw-600"
          @click="updateLegalMention()"
        >
          Enregistrer
        </b-button>
        <b-button
          v-else
          :disabled="isDisabled"
          class="button btn-blue my-4 fw-600"
          @click="createLegalMention()"
        >
          Enregistrer
        </b-button>
      </div>
      <appLoader v-if="isLoading" />
    </b-col>
  </b-row>
</template>
<script>
import ConfigurationMW from "@/middlewares/Configuration";
import ConfigurationORM from "@/store/orm-axios/models/Configuration";
import Tiptap from "@/components/snippets/Tiptap.vue";
export default {
  components: {
    Tiptap,
  },
  data() {
    return {
      legalMentions: "",
      configuration: null,
      isLegalMention: false,
      isLoading: true,
      isDisabled: false,
      dismissCountDownSuccess: 0,
      dismissCountDownError: 0,
      isNew: false,
    };
  },
  computed: {
    agencyId() {
      return Number(localStorage.getItem("agencyId"));
    },
    configurationComputed() {
      // There will be only one configuration for each agency id
      return ConfigurationORM.query().where("agency_id", this.agencyId).first();
    },
  },
  watch: {
    configurationComputed(newValue) {
      this.configuration = newValue;
      this.getLegalMentions();
    },
  },
  created() {
    ConfigurationMW.FETCH(this.agencyId)
      .then(() => {
        this.isLoading = false;
        this.configuration = this.configurationComputed;
        this.getLegalMentions();
        if (!this.configuration) {
          this.isNew = true;
        }
      })
      .catch(err => {
        this.isLoading = false;
      });
  },
  methods: {
    getLegalMentions() {
      // Get current legal mention value
      if (
        this.configuration &&
        this.configuration.settings &&
        this.configuration.settings.length > 0
      ) {
        this.configuration.settings.forEach(element => {
          if (element.legal_mentions) {
            this.legalMentions = element.legal_mentions;
            this.isLegalMention = true;
          }
        });
      }
    },
    setLegalMention() {
      // If legal mention exists in json, just update it
      if (this.isLegalMention) {
        this.configuration.settings.forEach(element => {
          if (element.legal_mentions) {
            element.legal_mentions = this.legalMentions;
          }
        });
      } else {
        // If json exists and legal mention is missing, add it to json
        if (
          this.configuration &&
          this.configuration.settings &&
          this.configuration.settings.length > 0
        ) {
          this.configuration.settings.push({
            legal_mentions: this.legalMentions,
          });
        } else if (this.configuration) {
          // If json is empty, add the legal mention object in an array
          this.configuration.settings = [
            {
              legal_mentions: this.legalMentions,
            },
          ];
        } else {
          // If json is null, add the legal mention object in an array
          this.configuration = [];
          this.configuration.settings = [
            {
              legal_mentions: this.legalMentions,
            },
          ];
        }
      }
    },
    countDownSuccessChanged(dismissCountDown) {
      this.dismissCountDownSuccess = dismissCountDown;
    },
    countDownErrorChanged(dismissCountDown) {
      this.dismissCountDownError = dismissCountDown;
    },
    updateLegalMention() {
      this.isDisabled = true;
      this.setLegalMention();
      ConfigurationMW.PUT(this.configuration)
        .then(() => {
          this.isDisabled = false;
          this.dismissCountDownSuccess = 5;
        })
        .catch(err => {
          this.isDisabled = false;
          this.dismissCountDownError = 5;
          console.log("err: ", err);
        });
    },
    createLegalMention() {
      this.isDisabled = true;
      this.setLegalMention();
      let configurationObj = {
        agencyId: this.agencyId,
        settings: this.configuration.settings,
      };
      ConfigurationMW.POST(configurationObj)
        .then(() => {
          this.isDisabled = false;
          this.dismissCountDownSuccess = 5;
        })
        .catch(err => {
          this.isDisabled = false;
          this.dismissCountDownError = 5;
          console.log("err: ", err);
        });
    },
    updateText(text) {
      this.legalMentions = text;
    },
  },
};
</script>
